import type { Failure, Result, Success } from './contracts';

export function isResult<TSuccess, TFailure = TSuccess>(
  v: unknown
): v is Result<TSuccess, TFailure> {
  return typeof v === 'object' && v != null && 'status' in v;
}

export function isSuccess<T>(v: unknown): v is Success<T> {
  return isResult<T>(v) && !Boolean(v.errorMessage) && v.content != null;
}

export function isFailure<T = never>(v: unknown): v is Failure<T> {
  return isResult<unknown, T>(v) && Boolean(v.errorMessage);
}
